import { useFlags } from '../../../hooks/use-flags';

import SwitchOptionsPage from './SwitchOptionsPage';
import SwitchPrescriptionPage from './SwitchPrescriptionPage';

export const SwitchPrescriptionRoot = () => {
    const { enableUpdatedDrugSwitchLilly } = useFlags();

    if (enableUpdatedDrugSwitchLilly) {
        return <SwitchOptionsPage />;
    }

    return <SwitchPrescriptionPage />;
};
